import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery'

import App from './App';


import { CartProvider } from './context/CartContext';

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.error = () => { };
  console.warn = () => { };
}

ReactDOM.render(
  <CartProvider>
    <App />
  </CartProvider>,
  document.getElementById('root'),
  function () {
    $('#preloader').delay(0).fadeOut();
  }
);

